
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class StoryGrid extends Serenity.EntityGrid<StoryRow, any> {
        protected getColumnsKey() { return StoryColumns.columnsKey; }
        protected getDialogType() { return StoryDialog; }
        protected getIdProperty() { return StoryRow.idProperty; }
        protected getInsertPermission() { return StoryRow.insertPermission; }
        protected getLocalTextPrefix() { return StoryRow.localTextPrefix; }
        protected getService() { return StoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());

            // *** Enable Full size grid resize ***
            Common.GridHelper.EnableFullSizeGrid();

            var test = new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return grid;
        }

        private autoSize;
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();

            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}